import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface LinhaOperadora {
  telefone: string;
  operadora: string | null;
  tipo_linha: string | null;
  data_portabilidade: string | null;
  fonte: string | null;
}

export function useLinhasOperadoraCnpj(cnpj: string | undefined) {
  const cnpjDigits = cnpj?.replace(/\D/g, '') || '';

  return useQuery({
    queryKey: ['linhas-operadora-cnpj', cnpjDigits],
    queryFn: async (): Promise<LinhaOperadora[]> => {
      if (!cnpjDigits) return [];
      const { data, error } = await supabase
        .from('linhas_cnpj_operadora' as any)
        .select('telefone, operadora, tipo_linha, data_portabilidade, fonte')
        .eq('cnpj', cnpjDigits);
      if (error) throw error;
      return (data || []) as unknown as LinhaOperadora[];
    },
    enabled: !!cnpjDigits,
    staleTime: 5 * 60 * 1000,
  });
}

/** Cria um Map para lookup rápido telefone -> operadora */
export function buildOperadoraMap(linhas: LinhaOperadora[]): Map<string, LinhaOperadora> {
  const map = new Map<string, LinhaOperadora>();
  for (const l of linhas) {
    const digits = l.telefone?.replace(/\D/g, '') || '';
    if (digits) {
      // Normalizar: guardar versões com e sem 55
      map.set(digits, l);
      if (digits.startsWith('55') && digits.length >= 12) {
        map.set(digits.slice(2), l);
      } else if (digits.length === 10 || digits.length === 11) {
        map.set(`55${digits}`, l);
      }
    }
  }
  return map;
}
